module.exports = __webpack_public_path__ + "img/retail_dispatch.2208c6d8.png";